import React, { useEffect } from 'react';
import { Button, DrawerBody, DrawerFooter, Alert, Typography, Skeleton, SkeletonLine, } from '@one-thd/sui-atomic-components';
import { InfoPerksContext, DrawerContext, RewardsAndOffersContext, } from '../../../../contexts';
import { PerkSlides, ListDrawerHeader } from './PerkListComponents';
import { rhAnalytics, rhDrawer, rhGeneral, } from '../../../../constants/RewardsHub';
import { useIsMobile } from '../../../../hooks';
import { analyticsOverlay } from '../../../../utils/analytics';
import { removeFromUrlParams } from '../../../Utils';
export var PerksListDrawer = function () {
    var setDrawerOpen = React.useContext(DrawerContext).setDrawerOpen;
    var _a = React.useContext(InfoPerksContext), isLoading = _a.isLoading, perksList = _a.perksList, unclaimedPerksList = _a.unclaimedPerksList, perksActivatedToday = _a.perksActivatedToday;
    var perksLink = rhGeneral.perksPage;
    var isPacDrawersEnabled = React.useContext(DrawerContext).isPacDrawersEnabled;
    var _b = React.useContext(InfoPerksContext), getPerksInfoPerksData = _b.getPerksInfoPerksData, hasError = _b.hasError, refreshPerks = _b.refreshPerks;
    var isChildAccount = React.useContext(RewardsAndOffersContext).isChildAccount;
    useEffect(function () {
        analyticsOverlay(rhAnalytics.perkAvailableDrawer);
    }, []);
    var handleClose = function () {
        removeFromUrlParams('drawerList');
        setDrawerOpen(false);
    };
    var SlidesSkeleton = function () {
        return (React.createElement(Skeleton, { grow: true },
            React.createElement(SkeletonLine, { variant: "multi", numberOfLines: 9 })));
    };
    var isMobile = useIsMobile().isMobile;
    var totalCount = (perksList === null || perksList === void 0 ? void 0 : perksList.length) +
        (unclaimedPerksList === null || unclaimedPerksList === void 0 ? void 0 : unclaimedPerksList.length) +
        (perksActivatedToday === null || perksActivatedToday === void 0 ? void 0 : perksActivatedToday.length);
    var perkCount = totalCount ? "(".concat(totalCount, ")") : "";
    var title = isChildAccount ? 'Company Perks' : 'Perks Available';
    return (React.createElement(React.Fragment, null,
        React.createElement(ListDrawerHeader, { title: "".concat(title, " ").concat(perkCount), handleClose: handleClose }),
        hasError ? (React.createElement(DrawerBody, null,
            React.createElement("div", { className: "sui-flex sui-flex-col" },
                React.createElement(Alert, { status: "error" },
                    React.createElement("div", null,
                        React.createElement(Typography, null, rhDrawer.PerkErrorMessage),
                        React.createElement("div", { className: "sui-text-base" },
                            React.createElement("button", { type: "button", onClick: function () {
                                    refreshPerks();
                                    getPerksInfoPerksData();
                                } },
                                React.createElement("u", null, "Refresh")))))))) : (React.createElement(React.Fragment, null,
            React.createElement(DrawerBody, null,
                React.createElement("div", { className: isMobile ? '' : 'sui-px-2 sui-pb-2' },
                    React.createElement("div", { className: "sui-pb-10 sui-text-base" }, rhDrawer.PerksListInfo),
                    isLoading ? React.createElement(SlidesSkeleton, null) : perksList && React.createElement(PerkSlides, null))),
            !isPacDrawersEnabled && (React.createElement(DrawerFooter, null,
                React.createElement("div", { className: "sui-flex sui-gap-2 sui-p-2" },
                    React.createElement(Button, { fullWidth: true, variant: "secondary", href: perksLink }, "Track Progress"))))))));
};
